import React, { useEffect, useState } from "react";
import { Dimensions, Keyboard, Platform, TouchableOpacity, View } from "react-native";
import { BottomBarDLSType, ButtonSizeDLS, ButtonTypeDLS, CalendarStateToken, ColorTokens, FontSizeTokens, IconSizeTokens, IconTokens, InputStateToken, InputTypeToken, KeyboardTypeToken, SizeTypeTokens, StackType, TextAlignTokens, TextInputTypeToken, TypographyTypeDLS } from "@voltmoney/schema";
import BoilerPlate from "../boilerPlate/BoilerPlate";
import { useMemo } from "react";
import CustomHeader from "../../customHeader/CustomHeader";
import Typography from "../../typography/Typography";
import Icon from "../../icon/Icon";
import TextInput from "../../textInput/TextInput";
import { RegexConfig } from "../constants";
import BottomBar from "../../bottomBarDLS/bottomBarDLS";
import { ModalAlignmentEnum } from "@voltmoney/types";
import Stack from "../../stack/Stack";
import Space from "../../space/Space";
import BottomSheet from "../BottomSheet";
import { isMobile } from "../../stack/utils";
import { getParameters, getScreenType } from "../utils";
import PanView from "../../panView/PanView";
import ButtonDLSBase from "../../button/ButtonDLS.base";
import NeedHelpDC from "../NeedHelpDC";
import * as Animatable from 'react-native-animatable';
import { createShimmerPlaceholder } from 'react-native-shimmer-placeholder';
import LinearGradient from 'react-native-linear-gradient';
let dob = "";
const CalendarPicker = ({ id, year, month, date, spacing = { size: SizeTypeTokens.XL }, action, triggerAction, caption, state = CalendarStateToken.DEFAULT, minYear = 0, maxYear = 0, metaData, onTextChange, closeModal, showErrorAnimation, ...props }) => {
    const [isFocus, setFocus] = useState(state === CalendarStateToken.FOCUS);
    const [isRefReady, setRefReady] = useState(false);
    const TextInputRefMap = { 0: null, 1: null, 2: null };
    useEffect(() => {
        if (isFocus && isRefReady) {
            TextInputRefMap[1].blur();
            TextInputRefMap[2].blur();
        }
    }, [isRefReady]);
    const [inputDate, setInputDate] = useState(date?.value);
    const [inputMonth, setInputMonth] = useState(month?.value);
    const [inputYear, setInputYear] = useState(year?.value);
    let params;
    if (Platform.OS === 'web') {
        params = getParameters(window?.location?.href);
    }
    const isDarkMode = params?.isDarkMode;
    const renderCaption = () => !caption ? (React.createElement(React.Fragment, null)) : (React.createElement(React.Fragment, null,
        React.createElement(Stack, { type: StackType.column },
            React.createElement(Space, { size: SizeTypeTokens.MD }),
            React.createElement(Stack, { type: StackType.row },
                state === CalendarStateToken.DEFAULT &&
                    caption.default && (React.createElement(Typography, { label: caption.default, fontSize: FontSizeTokens.XS, color: ColorTokens.Grey_Smoke, fontWeight: '400' })),
                state === CalendarStateToken.SUCCESS &&
                    caption.success && (React.createElement(Typography, { label: caption.success, fontSize: FontSizeTokens.XS, color: ColorTokens.System_Happy, fontWeight: '400' })),
                state === CalendarStateToken.ERROR &&
                    caption.error && (showErrorAnimation ? (React.createElement(Animatable.View, { animation: 'fadeIn', delay: 100, duration: 1000 },
                    React.createElement(Typography, { label: caption.error, fontSize: FontSizeTokens.XS, color: ColorTokens.System_Error, fontWeight: '400' }))) : (React.createElement(Typography, { label: caption.error, fontSize: FontSizeTokens.XS, color: ColorTokens.System_Error, fontWeight: '400' })))))));
    return (React.createElement(React.Fragment, null,
        React.createElement(View, { style: { flexDirection: 'row', alignItems: 'center', justifyContent: 'center' } },
            React.createElement(View, { style: {
                    flexDirection: 'row',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    width: '100%',
                } }, [date, month, year].map((item, index) => (React.createElement(View, { style: {
                    flex: 1,
                    marginRight: (index !== 2) ? 16 : 0,
                } },
                React.createElement(TextInput, { id: item.id, onlyNumeric: true, metaData: {
                        ...metaData,
                        widgetId: metaData?.widgetId + index,
                    }, isDarkMode: isDarkMode ? true : false, isFocus: false, value: item.value, keyboardType: KeyboardTypeToken.numeric, type: InputTypeToken.DEFAULT, onChangeText: (text) => {
                        if (index === 0 &&
                            `${text}`.length > 1 &&
                            date.value.length < 2) {
                            TextInputRefMap[1].focus();
                        }
                        else if (index === 1 &&
                            `${text}`.length > 1 &&
                            month.value.length < 2) {
                            TextInputRefMap[2].focus();
                        }
                        if (index === 0) {
                            date.value = text;
                            setInputDate(text);
                        }
                        else if (index === 1) {
                            month.value = text;
                            setInputMonth(text);
                        }
                        else {
                            year.value = text;
                            setInputYear(text);
                        }
                        if (index == 0) {
                            dob = `${text}-${inputMonth}-${inputYear}`;
                        }
                        else if (index == 1) {
                            dob = `${inputDate}-${text}-${inputYear}`;
                        }
                        else
                            dob = `${inputDate}-${inputMonth}-${text}`;
                        onTextChange(dob);
                        if (action && triggerAction) {
                            triggerAction({
                                ...action,
                                payload: {
                                    ...action.payload,
                                    value: dob,
                                },
                            });
                        }
                    }, title: item.title, placeholder: item.placeholder, width: TextInputTypeToken.FULL, state: InputStateToken[state === CalendarStateToken.ERROR
                        ? InputStateToken.ERROR
                        : state === CalendarStateToken.DISABLED ? InputStateToken.DISABLED : InputStateToken.DEFAULT], charLimit: index === 2 ? 4 : 2, charLimitVisibility: false, isSuccessIcon: false, getRef: (ref) => {
                        TextInputRefMap[index] = ref;
                        if (index === 2) {
                            setRefReady(true);
                        }
                    }, delayedRequestFocus: false })))))),
        renderCaption()));
};
const KycPanVerificationPage = ({ height, needHelpAction, goBackAction, triggerAction, continueAction, editPanAction, confirmPanAction, panAction, dobAction, state, caption, dobState, userName, year, month, date, prefilledPanNumber, showKycModal, showErrorModal, errorMessage, contactUsDetails, closePanModal, modalHeight, fetchedData, isFromJupiter, closeModal }) => {
    const [inputValue, setInputValue] = useState(prefilledPanNumber || '');
    const [currentState, setCurrentState] = useState(state);
    const [description, setDescription] = useState("");
    const [isLoading, setLoading] = useState(false);
    const [ctaLoading, setCtaLoading] = useState(false);
    const [dobValue, setDobValue] = useState(`${date?.value}-${month?.value}-${year?.value}`);
    const [showNeedHelp, setShowNeedHelp] = useState(false);
    const ShimmerPlaceholder = createShimmerPlaceholder(LinearGradient);
    let isDarkMode = null;
    if (Platform.OS === 'web') {
        const params = getParameters(window?.location?.href);
        isDarkMode = params?.isDarkMode;
    }
    const handleNeedHelp = () => {
        setShowNeedHelp(true);
    };
    useEffect(() => {
        if (showNeedHelp)
            Keyboard.dismiss();
    }, [showNeedHelp]);
    useEffect(() => {
        setInputValue(prefilledPanNumber);
    }, [prefilledPanNumber]);
    const headerChild = useMemo(() => {
        return (React.createElement(CustomHeader, { title: '', needHelpAction: handleNeedHelp, goBackAction: goBackAction, hideNeedHelp: false, isDarkMode: isDarkMode ? true : false, triggerAction: triggerAction, showNeedHelpNewArch: true }));
    }, []);
    const handlePress = async () => {
        if (continueAction) {
            setLoading(true);
            await triggerAction({
                ...continueAction,
                payload: {
                    ...continueAction.payload,
                    value: inputValue,
                }
            });
            setLoading(false);
        }
    };
    const footerChild = useMemo(() => {
        return (React.createElement(BottomBar, { id: "bt_verifyPanScreen_continue", typeDLS: BottomBarDLSType.TYPE_A, btnLoading: isLoading, btnLabel: 'Continue', btnTypeDLS: ButtonTypeDLS.PRIMARY, btnSizeDLS: ButtonSizeDLS.MEDIUM, isDarkMode: isDarkMode ? true : false, onPress: handlePress, isDisabled: dobState === CalendarStateToken.ERROR || currentState === InputStateToken.ERROR || dobValue?.length !== 10 || inputValue?.length !== 10 }));
    }, [dobState, currentState, isLoading]);
    useEffect(() => {
        setDescription(caption?.error);
        setCurrentState(state);
    }, [caption, state]);
    const handleTextChange = (newValue) => {
        setDobValue(newValue);
    };
    const renderContent = () => {
        return (React.createElement(Animatable.View, { animation: 'fadeIn', delay: 100, duration: 1000 },
            React.createElement(View, { style: { padding: 16, marginTop: 8 } },
                React.createElement(Typography, { color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night, typeDLS: TypographyTypeDLS.H3B, label: "Verify your PAN" }),
                React.createElement(View, { style: { marginTop: 8, padding: 8, backgroundColor: '#1096480D', borderRadius: 4, flexDirection: 'row' } },
                    React.createElement(Icon, { name: IconTokens.Secure, color: ColorTokens.Secondary_100, size: IconSizeTokens.MD }),
                    React.createElement(View, { style: { marginLeft: 4, flexDirection: 'row' } },
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: "We need your PAN to comply with", color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Charcoal }),
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2S, label: " RBI ", color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Charcoal }),
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: "regulations", color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Charcoal }))),
                fetchedData && React.createElement(View, { style: { marginTop: 20 } },
                    React.createElement(TextInput, { id: "tf_verifyPanScreen_enterPan", showErrorOnFocus: true, showErrorAnimation: true, isUpperCase: true, alphaNumeric: true, charLimit: 10, value: inputValue, isFocus: true, clearEnabled: false, isDarkMode: isDarkMode ? true : false, regex: RegexConfig.PAN, type: InputTypeToken.DEFAULT, state: showKycModal ? InputStateToken.DISABLED : currentState, title: "PAN", keyboardType: KeyboardTypeToken.default, placeholder: "Enter PAN", onChangeText: async (text) => {
                            setInputValue(text);
                            if (text.length === 10 && panAction) {
                                const panRegex = new RegExp(RegexConfig.PAN);
                                const isPanValid = panRegex.test(text);
                                if (!isPanValid) {
                                    setCurrentState(InputStateToken.ERROR);
                                    setDescription("Please enter a valid PAN number");
                                }
                                else {
                                    setCurrentState(InputStateToken.SUCCESS);
                                    setDescription('');
                                }
                            }
                            else
                                setCurrentState(InputStateToken.DEFAULT);
                        }, triggerAction: triggerAction, caption: {
                            error: `${(currentState === InputStateToken.ERROR && inputValue?.length === 10) ? `${description}` : ``}`
                        } })),
                !fetchedData && (React.createElement(ShimmerPlaceholder, { style: {
                        width: '100%',
                        height: 48,
                        marginTop: 20,
                        borderRadius: 8,
                    } })),
                (inputValue?.length !== 10 || currentState === InputStateToken.SUCCESS) && React.createElement(View, { style: { height: 15 } }),
                React.createElement(View, { style: { marginTop: 6, marginBottom: 12 } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B0S, label: "Date of birth (as per PAN)", color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night })),
                React.createElement(CalendarPicker, { year: {
                        id: `${year?.id}`,
                        title: 'Year',
                        value: `${year?.value}`,
                        placeholder: 'YYYY',
                    }, month: {
                        id: `${month?.id}`,
                        title: 'Month',
                        value: `${month?.value}`,
                        placeholder: 'MM',
                    }, date: {
                        id: `${date?.id}`,
                        title: 'Date',
                        value: `${date?.value}`,
                        placeholder: 'DD',
                    }, state: showKycModal ? CalendarStateToken.DISABLED : dobState, caption: {
                        success: "",
                        error: 'Age should be between 18 and 100'
                    }, triggerAction: triggerAction, action: dobAction, onTextChange: handleTextChange, showErrorAnimation: true }))));
    };
    const handleCloseModal = async () => {
        if (handleCloseModal) {
            await triggerAction(closePanModal);
        }
    };
    const handleEditButton = async () => {
        if (handleCloseModal) {
            await triggerAction(closePanModal);
        }
    };
    const handleConfirmButton = async () => {
        if (confirmPanAction) {
            setCtaLoading(true);
            await triggerAction({
                ...confirmPanAction,
                payload: {
                    ...confirmPanAction.payload,
                    panNumber: inputValue,
                }
            });
            setCtaLoading(false);
        }
    };
    const modalContentPresenter = () => {
        return (React.createElement(View, { style: { padding: 16, marginTop: 8 } },
            React.createElement(Typography, { typeDLS: TypographyTypeDLS.H2B, label: "Confirm PAN details", textAlign: TextAlignTokens.center, color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night }),
            React.createElement(View, { style: { marginTop: 16 } },
                React.createElement(PanView, { name: userName, panNumber: inputValue })),
            React.createElement(View, { style: { marginTop: 24 } },
                React.createElement(ButtonDLSBase, { id: "bt_confirmPanScreen_Confirm", sizeDLS: ButtonSizeDLS.MEDIUM, loading: ctaLoading, typeDLS: ButtonTypeDLS.PRIMARY, label: 'Yes, I confirm', onPress: handleConfirmButton, isDisabled: false })),
            React.createElement(View, { style: { marginTop: 12 } },
                React.createElement(ButtonDLSBase, { id: "bt_confirmPanScreen_edit", sizeDLS: ButtonSizeDLS.MEDIUM, loading: ctaLoading, typeDLS: ButtonTypeDLS.SECONDARY, label: 'Edit PAN details', onPress: handleEditButton, isDisabled: false }))));
    };
    const errorModalContentPresenter = () => {
        return (React.createElement(TouchableOpacity, { activeOpacity: 1, style: { padding: 16, zIndex: 1, flex: 1 } },
            React.createElement(View, { style: { alignItems: 'center' } },
                React.createElement(Icon, { name: IconTokens.SystemError })),
            React.createElement(View, { style: { marginTop: 16 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.H4S, color: ColorTokens.Grey_Night, textAlign: TextAlignTokens.center, label: "Verification failed!" })),
            React.createElement(View, { style: { marginTop: 2 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Charcoal, textAlign: TextAlignTokens.center, label: errorMessage })),
            React.createElement(View, { style: { marginTop: 24 } },
                React.createElement(ButtonDLSBase, { id: "bt_confirmPanScreen_reEnterDetails", sizeDLS: ButtonSizeDLS.MEDIUM, typeDLS: ButtonTypeDLS.PRIMARY, label: 'Change PAN', onPress: () => {
                        triggerAction({
                            ...closeModal
                        });
                    }, isDisabled: false }))));
    };
    const modalScreen = () => {
        return showKycModal ? (React.createElement(View, { style: {
                position: 'absolute',
                bottom: 0,
                zIndex: 99
            } },
            React.createElement(BottomSheet, { autoAdjustHeight: false, height: modalHeight, width: '100%', closeFunction: handleCloseModal, alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: isDarkMode ? '#0D141F' : 'white', isDismissible: false, radius: 4, screenHeight: height, screenWidth: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').width : 508, routeId: "routeId", handleKeyboard: true }, modalContentPresenter()))) : React.createElement(React.Fragment, null);
    };
    const errorModalScreen = () => {
        return showErrorModal ? (React.createElement(View, { style: {
                position: 'absolute',
                bottom: 0,
                zIndex: 99
            } },
            React.createElement(BottomSheet, { autoAdjustHeight: false, height: modalHeight, width: '100%', closeFunction: () => {
                    triggerAction({
                        ...closeModal
                    });
                }, alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: true, radius: 4, screenHeight: height, screenWidth: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').width : 508, routeId: "routeId", handleKeyboard: true }, errorModalContentPresenter()))) : React.createElement(React.Fragment, null);
    };
    return (React.createElement(BoilerPlate, { height: height, backgroundColor: isDarkMode ? ColorTokens.DARK_MODE : ColorTokens.White, headerChild: headerChild, heightHeader: Platform.OS === 'ios' ? 93 : 57, bottomChildren: React.createElement(React.Fragment, null,
            footerChild,
            modalScreen(),
            errorModalScreen(),
            showNeedHelp && React.createElement(NeedHelpDC, { showNeedHelp: showNeedHelp, setShowNeedHelp: setShowNeedHelp, contactUsDetails: contactUsDetails, isFromJupiter: isFromJupiter })) },
        React.createElement(React.Fragment, null, renderContent())));
};
export default KycPanVerificationPage;
